import { InfoButton, Text } from '@bbl-digital/snorre'
import {
  getFormattedPriceWithEnding,
  IconInfo,
  useIsMobile,
} from '@bbl-digital/snorre-v2'
import { FC, useEffect } from 'react'
import ErrorText from 'shared/components/ErrorText'
import Flex from 'shared/components/Flex'
import {
  getMaxCountForCurrentSms,
  getTotalSmsCount,
} from 'shared/components/SendMessageHandler/shared/utils/send-sms-helper'
import { ISendSmsSettings } from 'shared/models/Message'

interface IProps {
  contentChars: number
  numberOfRecipients: number
  settings: ISendSmsSettings
  onMaxLimitReached: (isReached: boolean) => void
}

const SmsInformation: FC<IProps> = ({
  contentChars,
  settings,
  numberOfRecipients,
  onMaxLimitReached,
}) => {
  const isMobile = useIsMobile()
  const smsCount = getTotalSmsCount(contentChars)
  const maxCountForCurrerntSms = getMaxCountForCurrentSms(contentChars)
  const totalSmsCount = smsCount * numberOfRecipients
  const warningLimitReached =
    settings.numberOfSmsNotInvoiced >= settings.warningLimit
  const totalCost = totalSmsCount * settings.unitPrice
  const isMaxLimitReached =
    Boolean(settings.maxLimit) &&
    totalSmsCount + settings.numberOfSmsNotInvoiced > settings.maxLimit

  useEffect(() => {
    onMaxLimitReached(isMaxLimitReached)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMaxLimitReached])

  return (
    <>
      <Flex
        flexDirection={isMobile ? 'column' : 'row'}
        gap="1rem"
        alignItems={isMobile ? 'flex-start' : 'center'}
      >
        <Text>
          {contentChars}/{maxCountForCurrerntSms} tegn ({smsCount} SMS) Totalt{' '}
          {totalSmsCount} SMS. Pris per SMS:{' '}
          {getFormattedPriceWithEnding(settings.unitPrice, 2)} (Totalt:{' '}
          {getFormattedPriceWithEnding(totalCost, 2)})
        </Text>
        {isMobile ? (
          <Text>
            Emojis og spesialtegn bruker flere tegn enn vanlige bokstaver og kan
            derfor øke antall SMS-er som sendes.
          </Text>
        ) : (
          <InfoButton icon={<IconInfo />} place="top">
            Emojis og spesialtegn bruker flere tegn enn vanlige bokstaver og kan
            derfor øke antall SMS-er som sendes.
          </InfoButton>
        )}
      </Flex>

      {warningLimitReached && !isMaxLimitReached && (
        <Text>
          Til informasjon, så er det nå sendt mer enn{' '}
          {settings.numberOfSmsNotInvoiced} SMS siden forrige faktura. Det er
          fortsatt anledning til å sende flere SMS.
        </Text>
      )}

      {isMaxLimitReached && (
        <ErrorText
          withIcon={false}
          text="Maksgrense for antall sendte SMS er nådd"
        />
      )}
    </>
  )
}

export default SmsInformation
